import {
  Grid,
  Avatar,
  Box,
  Typography,
  styled,
  Container,
  Stack,
  Button,
  IconButton,
} from "@mui/material";
import Cards from "components/MyActivityComponents/Cards";
import LocationCard from "components/MyActivityComponents/Cards/LocationCard";
import useMediaQuery from "@mui/material/useMediaQuery";
import CloseIcon from "@mui/icons-material/Close";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useGetAllOrderRelatedSubsQuery } from "api/order";

const HeaderTitle = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "24px",
  letterSpacing: "0.015em",
  color: "#1A1824",
}));

const Title = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "20px",
  letterSpacing: "0.015em",
  color: "#1A1824",
}));

const LightTitle = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "160%",
  letterSpacing: "0.015em",
  color: "#9EA3AE",
}));

const FlexBox = styled(Box)(({ theme }) => ({
  display: "flex",
  textAlign: "center",
  justifyContent: "center",
}));

const SideBarContainer = styled(Typography)(({ theme, matches }) => ({
  display: matches ? undefined : "none",
  paddingRight: 0,
  height: "100%",
  minWidth: "310px",
  // position: "fixed",
  // zindex: "1",
  top: 0,
  right: 0,
  overflowX: "hidden",
  paddingTop: "20px",
  borderLeft: "1px solid #E1E1E6",
}));

const TrackOrder = () => {
  const matches = useMediaQuery("(min-width:1320px)");
  const [trackBar, setTrackBar] = useState(false);
  const { data: order, isLoading } = useGetAllOrderRelatedSubsQuery();

  return isLoading ? (
    <p>Loading...</p>
  ) : (
    <Container maxWidth="xl" sx={{pt:2}}>
      <>
        <Grid container spacing={2}>
          <Grid item sx={8} md={matches ? 8 : 12} style={{ padding: "10px" }}>
            <HeaderTitle>EatCoast Gift Card</HeaderTitle>

            <LocationCard
              title={"My Home"}
              subTitle={"George Street. St."}
              hasDefaultButton
              onDefaultClick={() => {
                console.log("default clicked");
              }}
              changeAddressButton
              imageSrc={require("../../assets/Vectorhome.png")}
            />
            {
              order && order.length > 0 ? (
                <>
                {order &&
              order?.map((item) => {
                let orderTemp = {
                  img: "https://picsum.photos/200",
                  label: "Personal subscription",
                  heading: "Baked Fish Fillets with Cheese Sauce",
                  address: "Chef Juna Food, 4474 Bridge",
                  date: "12 Oct -12 Nov 2021",
                  chipColor: "#7B49E5",
                };
                if (item) {
                  orderTemp.date = `${new Date(
                    item.deliveryDetails[0].subscriptionId.from
                  ).toDateString()} - ${new Date(
                    item.deliveryDetails[0].subscriptionId.to
                  ).toDateString()} `;
                  orderTemp.address = item.deliveryDetails[0].deliveryTo.address;
                  orderTemp.label = item.deliveryDetails[0].subscriptionId.type
                }
                return (
                  <Link style={{ textDecoration: "none" }}>
                    <Box onClick={() => setTrackBar(true)}>
                      <Cards
                        data={orderTemp}
                        handleChange={(e) => {
                          console.log("eee", e);
                        }}
                        hasActionButton={false}
                      />
                    </Box>
                  </Link>
                );
              })}
                </>
              ) : (
                <>

                </>
              )
            }
            
          </Grid>
          <Grid item sx={4} md={4} style={{}}>
            {trackBar ? (
              <SideBarContainer matches={matches}>
                <IconButton
                  component="label"
                  onClick={() => setTrackBar(false)}
                >
                  <CloseIcon style={{ color: "#E75C62" }} />
                </IconButton>

                <Stack spacing={"110%"}>
                  <Box style={{ textAlign: "center", padding: "10px" }}>
                    <FlexBox>
                      <Avatar
                        alt="Remy Sharp"
                        src="../../assets/Vectorhome.png"
                        sx={{ width: 56, height: 56 }}
                      />
                    </FlexBox>
                    <Title>Your Order is On the Way</Title>
                    <LightTitle>
                      You will receive your delivery in 20 - 30 minutes
                    </LightTitle>
                  </Box>

                  <Box
                    style={{
                      borderTop: "1px solid #E1E1E6",
                      padding: "10px",
                    }}
                  >
                    <Box
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        marginBottom: "10px",
                      }}
                    >
                      <Avatar
                        alt="Remy Sharp"
                        src="../../assets/Vectorhome.png"
                        sx={{ width: 48, height: 48 }}
                      />
                      <Title>Sarmad Bokhari</Title>
                    </Box>

                    <Box
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Button
                        variant="outlined"
                        startIcon={<ChatOutlinedIcon />}
                        style={{ width: "100%", marginRight: 10 }}
                      >
                        Message
                      </Button>
                      <Button
                        variant="outlined"
                        startIcon={<PhoneOutlinedIcon />}
                        style={{ width: "100%" }}
                      >
                        Call
                      </Button>
                    </Box>
                  </Box>
                </Stack>
              </SideBarContainer>
            ) : (
              ""
            )}
          </Grid>
        </Grid>
      </>
    </Container>
  );
};

export default TrackOrder;
